export default __webpack_public_path__ + "src/assets/membership-onemonth.3e984bb10cbef62671e7febfb9ba557b.svg";